export class Assignment {
  //date: number;
  //title: string;
  //username: string;
  id: string;
  name: string;
  processInstanceId: string;
  processBusinessKey: string;
  processName: string;
  assignee: string;
  dueDate: string;
  displayStatus: string;

  constructor(init?: Partial<Assignment>) {
    Object.assign(this, init);
  }

  static parse(data: Partial<Assignment>): Assignment {
    const parsed = new Assignment();
    parsed.id = data.id!;
    parsed.name = data.name!;
    parsed.processInstanceId = data.processInstanceId!;
    parsed.processBusinessKey = data.processBusinessKey!;
    parsed.processName = data.processName!;
    parsed.assignee = data.assignee!;
    parsed.dueDate = data.dueDate!;
    parsed.displayStatus = data?.name ? this.parseDisplayedStatus(data.name!) : data.name;
    return parsed;
  }

  static parseDisplayedStatus(status: string): string {
    const statusDict = {
      ["task_edit_change_request"]: "Editable",
      ["task_saf_review"]: "SAF Review",
      ["task_nof_review"]: "NOF Review",
      ["task_nof_perm_notam"]: "NOF Perm NOTAM",
      ["task_ais_review"]: "AIS Review",
      ["end_implemented_with_perm_notam"]: "Implemented with perm NOTAM",
      ["end_implemented"]: "Implemented",
      ["end_notam_request_accepted"]: "NOTAM Accepted",
      ["end_cancelled"]: "Cancelled",
    };
    // Return the value from the dictionary or fallback to original status
    return statusDict[status] ?? status;
  }
}
